import type { ProductHit } from '@libs/algolia';
import { getProductRecommendations } from '@libs/api-proxy-client';
import { logger } from '@libs/core/utils';

type FetchRecommendedProductsOptions = {
    productIds: string[];
    customerId: string;
    storeId: string;
};

/** Cap URL length for comma-separated product path (~200 chars / ~25 SKUs). */
const MAX_PRODUCT_IDS = 25;

function removeDuplicateProducts(products: ProductHit[]) {
    return products.filter(
        (product, index, self) => index === self.findIndex(productSelf => productSelf.id === product.id)
    );
}

export const fetchRecommendedProducts = async ({
    productIds,
    customerId,
    storeId,
}: FetchRecommendedProductsOptions): Promise<ProductHit[]> => {
    try {
        const uniqueProductIds = [...new Set(productIds.filter(Boolean))].slice(0, MAX_PRODUCT_IDS);

        if (!uniqueProductIds.length) {
            return [];
        }

        const fetchedProducts = await getProductRecommendations({
            productIds: uniqueProductIds,
            storeId,
            customerId,
        });

        return removeDuplicateProducts(fetchedProducts);
    } catch (error) {
        logger.error('Error fetching product recommendations: %o', error);
        throw error;
    }
};
